import { reloadAds } from '@utils/advertisement';
import { articleListedState as state } from './articleListedState';
import {
  articleListedToggleChapter as toggleChapter,
  activeChapterToInfoBox,
} from './articleListedToggleChapter';
import { articleListedLoadButtons as loadButtons } from './articleListedLoadButtons';
import { targetTopScroll } from './articleListedScrollCalc';
import { addChapterUrlParam } from './articleListedChapterUrlParam';
import { hasSelectElementPagination, btnsNextHref, btnsPrevHref } from './articleListedElements';
import { getElementComputedDimensions } from '@utils/elements';
import { pauseAllVideos } from '../../../utils/pauseAllVideos';

import {
  articlePartPrev,
  articlePartNext,
} from '../../../components/analytics/GoogleTagManager/GTMArticle';

// Znovu načíst aktuální kapitolu
export const reload = () => {
  toggleChapter();

  // Načíst tlačítka
  loadButtons();
  activeChapterToInfoBox();

  if (hasSelectElementPagination) {
    // Scroll na začátek článku listovačky se selectem (např. auto.cz)
    const headerHeight = getElementComputedDimensions(
      document.querySelector('header') as HTMLDivElement
    ).height;
    const scrollOffset = 20;
    const scrollPosition =
      hasSelectElementPagination.getBoundingClientRect().top +
      document.documentElement.scrollTop -
      headerHeight -
      scrollOffset;
    window.scroll({
      top: scrollPosition,
      left: 0,
      behavior: 'smooth',
    });
  } else {
    // Scroll na začátek článku Uniweb listovačka
    window.scrollTo({
      top: targetTopScroll(),
      behavior: 'smooth',
    });
  }

  // Upravit odkazy na dalších tlačítkách
  btnsNextHref.forEach((btnNextHref) => {
    btnNextHref.setAttribute('href', `${document.location.pathname}${document.location.pathname}?chapter=${state.getActiveChapter() + 1}`);
  });

  // Upravit odkazy na předchozích tlačítkách
  btnsPrevHref.forEach((btnsPrevHref) => {
    btnsPrevHref.setAttribute('href', `${document.location.pathname}${document.location.pathname}?chapter=${state.getActiveChapter() - 1}`);
  });

  // Reloadovat reklamu
  reloadAds();
};

// Návrat na první kapitolu
export const home = () => {
  state.setActiveChapter(1);

  addChapterUrlParam(1);
  activeChapterToInfoBox();

  articlePartPrev(1).then(
    () => {},
    () => {}
  );

  reload();
};

// Další kapitola
export const next = () => {
  // pausa všech videí před přechodem na další kapitolu
  pauseAllVideos();

  // Poslední kapitole | Návrat na první kapitolu
  if (state.getIsLast()) {
    home();
    return;
  }

  state.increaseActiveChapter();

  addChapterUrlParam(state.getActiveChapter());
  activeChapterToInfoBox();

  articlePartNext(state.activeChapter).then(
    () => {},
    () => {}
  );

  reload();
};

// Předchozí kapitola
export const prev = () => {
  // pausa všech videí před přechodem na předchozí kapitolu
  pauseAllVideos();

  // První kapitole | Bez akce
  if (state.activeChapter === 1) {
    return;
  }

  state.decreaseActiveChapter();

  addChapterUrlParam(state.getActiveChapter());
  activeChapterToInfoBox();

  articlePartPrev(state.activeChapter).then(
    () => {},
    () => {}
  );

  reload();
};
